import React from 'react';
import LinkOriginal, { LinkProps } from 'next/dist/client/link';

type TLinkProps = React.FC<Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & LinkProps & {
    children?: React.ReactNode,
} & React.RefAttributes<HTMLAnchorElement>>;

const LinkWithoutPrefetch: TLinkProps = (props) => {
    return <LinkOriginal {...props} prefetch={props.prefetch ?? false}></LinkOriginal>;
};

export default LinkWithoutPrefetch;
